<hs-tab-group>
  <hs-tab [label]="detailsLabel"
    ><ng-container *ngTemplateOutlet="detailsTabContent"></ng-container
  ></hs-tab>
  @if (!isTemplate()) {
    <hs-tab [label]="mediaLabel">
      <div class="kfm-sales-details-tab-media">
        <kfm-media-gallery
          [galleries]="galleries()"
          [isEditable]="isEditable()"
        ></kfm-media-gallery>
      </div>
    </hs-tab>
  }
</hs-tab-group>

<ng-template #detailsTabContent>
  <div class="kfm-sales-details-tab-content">
    @if (showStatusHistoryCard()) {
      <kfm-status-history-card
        [history]="statusHistory()"
        [isEditable]="isEditable()"
        (historyChanged)="onStatusHistoryChanged($event)"
      ></kfm-status-history-card>
    }

    @if (internalSalesItem()) {
      <kfm-sales-details-card
        [salesItem]="internalSalesItem()!"
        [isEditable]="isEditable()"
        (appointmentChanged)="onAppointmentChanged()"
        (salesItemChanged)="onSalesItemChanged($event)"
      ></kfm-sales-details-card>
    }

    @if (showCustomerCard()) {
      <div class="flex flex-row gap-2 w-full">
        <div class="w-1/2">
          <ng-container *ngTemplateOutlet="customerTmpl"></ng-container>
        </div>
        <div class="w-1/2">
          <ng-container *ngTemplateOutlet="locationTmpl"></ng-container>
        </div>
      </div>
    }

    @if (
      (isTask() || isAppointment()) && !isTemplate() && internalSalesItem()
    ) {
      <kfm-appointment-date-card
        [appointment]="internalSalesItem()!"
        [isEditable]="isEditable()"
        (appointmentChanged)="onAppointmentChanged()"
        (taskChanged)="onTaskChanged($event)"
      ></kfm-appointment-date-card>
    }

    @if (showShoppingCard() && internalSalesItem()) {
      <kfm-shopping-cart
        [owner]="internalSalesItem()!"
        [isEditable]="isEditable()"
      ></kfm-shopping-cart>
    }

    @if (!isAppointment()) {
      <kfm-print-settings-card
        [report]="report()!"
        [collapsed]="!isTemplate()"
        [editable]="isEditable()"
      ></kfm-print-settings-card>
    }

    @if (showReportCard() && !isTemplate()) {
      <kfm-report-card
        [report]="report()!"
        [isEditable]="isEditable()"
      ></kfm-report-card>
    }

    @if (isTask() && !isTemplate()) {
      <div class="flex flex-row flex-wrap gap-2">
        <kfm-signature-card
          [cardTitle]="customerSignatureLabel"
          [dataUrl]="customerSignature()"
          [isEditable]="isEditable()"
          (signatureChanged)="onCustomerSignatureChanged($event)"
        ></kfm-signature-card>
        <kfm-signature-card
          [cardTitle]="mechanicSignatureLabel"
          [dataUrl]="mechanicSignature()"
          [isEditable]="isEditable()"
          (signatureChanged)="onMechanicSignatureChanged($event)"
        ></kfm-signature-card>
      </div>
    }

    <div class="flex flex-row gap-2 w-full justify-end mt-4 pr-20">
      @if (isAppointment() && isEditable()) {
        <button
          hsButton
          hsButtonSize="md"
          hsButtonVariant="outlined"
          (click)="onPrintAppointmentClicked()"
        >
          <hs-icon [innerHTML]="printIcon"></hs-icon>
        </button>
        <button
          hsButton
          hsButtonSize="md"
          hsButtonColor="danger"
          hsButtonVariant="outlined"
          (click)="onDeleteAppointmentClicked()"
        >
          <hs-icon [innerHTML]="deleteIcon"></hs-icon>
        </button>
      } @else if ((isTask() || isInvoice() || isOffer()) && !isTemplate()) {
        <!-- Drucken: immer sichtbar für Task, Offer, Invoice -->

        <!-- <button hsButton hsButtonSize="md" hsButtonVariant="outlined" [hsTooltip]="printTaskLabel" (click)="onPrintTaskClicked()">
            <hs-icon [innerHTML]="printIcon"></hs-icon>
          </button>
          <button hsButton hsButtonSize="md" hsButtonVariant="outlined" [hsTooltip]="convertTaskLabel" (click)="onConvertClicked()">
            <hs-icon [innerHTML]="convertIcon"></hs-icon>
          </button>
          <button hsButton hsButtonSize="md" hsButtonColor="danger" hsButtonVariant="outlined" [hsTooltip]="deleteTaskLabel" (click)="onDeleteTaskClicked()">
            <hs-icon [innerHTML]="deleteIcon"></hs-icon>
          </button> -->

        <ng-container *ngTemplateOutlet="printButtonTmpl"></ng-container>

        <!-- Herunterladen: nur bei gebuchten/stornierten Rechnungen -->
        @if (isInvoice() && (isBooked() || isCancelled())) {
          <ng-container *ngTemplateOutlet="downloadButtonTmpl"></ng-container>
        }

        <!-- Konvertieren: für Offer und Invoice -->
        <ng-container *ngTemplateOutlet="convertButtonTmpl"></ng-container>

        <!-- Konvertieren & Löschen: Task -->
        @if (isTask()) {
          <button hsButton hsButtonSize="md" hsButtonVariant="outlined" [hsTooltip]="convertTaskLabel" (click)="onConvertClicked()">
            <hs-icon [innerHTML]="convertIcon"></hs-icon>
          </button>

          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="danger"
            hsButtonVariant="outlined"
            [hsTooltip]="deleteTaskLabel"
            (click)="onDeleteTaskClicked()"
          >
            <hs-icon [innerHTML]="deleteIcon"></hs-icon>
          </button>
        }

        <!-- Löschen: nur bei offener Rechnung oder Angebot -->
        @if (isInvoice() && !isCancelled() && !hasActiveBooking()) {
          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="danger"
            hsButtonVariant="outlined"
            [hsTooltip]="deleteInvoiceLabel"
            (click)="onDeleteInvoiceClicked()"
          >
            <hs-icon [innerHTML]="deleteIcon"></hs-icon>
          </button>
        }
        @if (isOffer()) {
          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="danger"
            hsButtonVariant="outlined"
            [hsTooltip]="deleteOfferLabel"
            (click)="onDeleteOfferClicked()"
          >
            <hs-icon [innerHTML]="deleteIcon"></hs-icon>
          </button>
        }

        <!-- Primär-Aktionen -->
        @if (isInvoice() && !isCancelled() && !hasActiveBooking()) {
          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="success"
            hsButtonVariant="filled"
            [disabled]="isShoppingCartSaving()"
            [hsTooltip]="isShoppingCartSaving() ? savingItemsTooltip : ''"
            (click)="onBookInvoiceClicked()"
          >
            <hs-icon [innerHTML]="finishIcon"></hs-icon>
            {{ bookInvoiceButtonLabel }}
          </button>
        } @else if (isInvoice() && !isCancelled() && hasActiveBooking()) {
          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="danger"
            hsButtonVariant="filled"
            (click)="onCancelInvoiceClicked()"
          >
            <hs-icon [innerHTML]="cancelIcon"></hs-icon>
            {{ cancelInvoiceLabel }}
          </button>
        } @else if (isTask() && isEditable() && !isTemplate()) {
          <button
            hsButton
            hsButtonSize="md"
            hsButtonColor="success"
            hsButtonVariant="filled"
            (click)="onFinishTaskClicked()"
          >
            <hs-icon [innerHTML]="finishIcon"></hs-icon>
            {{ finishTaskLabel }}
          </button>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #customerTmpl let-node="ctxNode">
  <kfm-contact-card
    [contact]="customer()"
    (contactAdded)="onCustomerAdded($event)"
    (contactRemoved)="onCustomerRemoved()"
    [cardTitle]="customerCardTitle"
    [cardIcon]="customerCardIcon"
    [isEditable]="isEditable()"
  ></kfm-contact-card>
</ng-template>

<ng-template #locationTmpl let-node="ctxNode">
  <kfm-contact-card
    [contact]="location()"
    (contactAdded)="onLocationAdded($event)"
    (contactRemoved)="onLocationRemoved()"
    [cardTitle]="locationCardTitle"
    [cardIcon]="locationCardIcon"
    [isEditable]="isEditable()"
  ></kfm-contact-card>
</ng-template>

<ng-template #printButtonTmpl let-node="ctxNode">
  <button
    hsButton
    hsButtonSize="md"
    hsButtonVariant="outlined"
    [hsTooltip]="
      isInvoice()
        ? printInvoiceLabel
        : isOffer()
          ? printOfferLabel
          : printTaskLabel
    "
    [hsTooltip]="
      isInvoice()
        ? printInvoiceLabel
        : isOffer()
          ? printOfferLabel
          : printTaskLabel
    "
    (click)="onPrintClicked()"
  >
    <hs-icon [innerHTML]="printIcon"></hs-icon>
  </button>
</ng-template>

<ng-template #downloadButtonTmpl let-node="ctxNode">
  <button
    hsButton
    hsButtonSize="md"
    hsButtonVariant="outlined"
    [hsTooltip]="downloadDocumentLabel"
    (click)="onDownloadInvoiceClicked()"
  >
    <hs-icon [innerHTML]="downloadIcon"></hs-icon>
  </button>
</ng-template>

<ng-template #convertButtonTmpl let-node="ctxNode">
  <button
    hsButton
    hsButtonSize="md"
    hsButtonVariant="outlined"
    [hsTooltip]="
      isOffer()
        ? convertOfferLabel
        : isTask()
          ? convertTaskLabel
          : convertInvoiceLabel
    "
    (click)="onConvertClicked()"
  >
    <hs-icon [innerHTML]="convertIcon"></hs-icon>
  </button>
</ng-template>

<ng-template #deleteButtonTmpl let-node="ctxNode">
  <button
    hsButton
    hsButtonSize="md"
    hsButtonColor="danger"
    hsButtonVariant="outlined"
    [hsTooltip]="
      isOffer()
        ? deleteOfferLabel
        : isTask()
          ? deleteTaskLabel
          : deleteInvoiceLabel
    "
    (click)="onDeleteClicked()"
  >
    <hs-icon [innerHTML]="deleteIcon"></hs-icon>
  </button>
</ng-template>
